<template>
  <div class="flex w-full items-center justify-center p-4">
    <Button color="text-b-b" size="md" class="w-full h-10" @click="emit('back-login')">
      <Icon icon="Function-Wireframe-User" class="size-5" />
      {{ $t('home.user.backLoginButton') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
  import { Button, Icon } from '@rapoo/element'

  const emit = defineEmits<{
    (e: 'back-login'): void
  }>()
</script>
